import React from 'react';
import { createRoot, Root } from 'react-dom/client';

import App from './app';

let entryPoint: HTMLButtonElement;
let root: Root;

const initApp = (): void => {
  const mobileMenu = entryPoint.dataset.mmenu
    ? JSON.parse(entryPoint.dataset.mmenu)
    : null;

  root = createRoot(entryPoint);
  root.render(
    React.createElement(App, {
      mobileMenu,
    }),
  );
};

const init = (): void => {
  entryPoint = document.querySelector('#denso-mobile-menu');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
